import {Component, Input, OnInit} from '@angular/core';
import {NavStatusService} from "../nav-status.service";
import {NavigationPoint} from "../navigation-point";
import {MatIcon} from "@angular/material/icon";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
  selector: 'app-error-pages',
  imports: [
    MatIcon,
    TranslatePipe
  ],
  templateUrl: './error-pages.component.html',
  styleUrl: './error-pages.component.scss'
})
export class ErrorPagesComponent implements OnInit {

  @Input() errorType: string | undefined;
  constructor( private navStatusService: NavStatusService,) {

  }

  ngOnInit() {
    console.log('hu', this.errorType);
    this.navStatusService.setActiveNavPoint(NavigationPoint.error)
  }

}
